import productionPlanReducer from "./reducers";

export default productionPlanReducer;